<template>
  <div>
    <el-form :model="queryParams" :inline="true">
      <el-form-item prop="dateRange" v-if="type === 2">
        <el-date-picker
          format="yyyy-MM"
          value-format="yyyy-MM"
          v-model="dateRange"
          @change="search"
          type="monthrange"
          range-separator="-"
          start-placeholder="开始月份"
          end-placeholder="结束月份">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-if="type === 1">
        <el-date-picker
          format="yyyy-MM"
          value-format="yyyy-MM"
          v-model="queryParams.date"
          @change="search"
          type="month"
          placeholder="选择月流量">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div id="chart" :class="className" :style="{height:height,width:width}" />
  </div>
</template>

<script>
import * as echarts from "echarts"
import resize from '@/views/dashboard/mixins/resize'
import { lineChartMultiNetFlow } from "@/api/multiNet.js"
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    groupNo: {
      type: String,
    },
    type: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      chart: null,
      queryParams: {
        date: '',
        groupNo: this.groupNo,
        type: this.type
      },
      dateRange: []
    }
  },
  watch: {
    groupNo() {
      this.queryParams.groupNo = this.groupNo
      this.queryParams.type = this.type
      this.initChart()
    },
    type() {
      this.queryParams.type = this.type
      this.initChart()
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!!this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      document.getElementById("chart").style.width = (window.innerWidth / 7) * 5 + 'px'
      this.chart = echarts.init(document.getElementById("chart"))
      if (!this.chart) {
        return
      }
      lineChartMultiNetFlow(this.queryParams).then(res => {
        if (this.chart) {
          this.setOptions(this.chart, res.data.data)
          this.chart.resize()
        }
      })
    },
    setOptions(chart, { timeList, monthList } = {}) {
      chart.setOption({
        title: {
          text: '流量统计'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: [{
            name: this.iccid,
            textStyle: {
              color: 'red',
              fontSize: 16
            }
          }]
        },
        toolbox: {
          show: true,
          feature: {
            magicType: { show: true, type: ['line', 'bar'] }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: timeList
          }
        ],
        yAxis: [
          {
            type: 'value',
            position: 'left',
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#1890ff'
              }
            },
            axisLabel: {
              formatter: '{value} MB'
            }
          }
        ],
        series: [
          {
            name: this.iccid,
            type: 'line',
            data: monthList,
            label: {
              show: true,
              position: "top",
              distance: 6,
              fontSize: 14,
              color: "#1890ff"
            }
          }
        ]
      })
    },
    search() {
      let param = this.addDateRange(this.queryParams, this.dateRange)
      this.chart = echarts.init(document.getElementById("chart"))
      lineChartMultiNetFlow(param).then(res => {
        this.setOptions(this.chart, res.data.data)
      })
    }
  }
}
</script>
<style scoped lang="less">
.el-loading-mask {
  z-index: 2000;
}
</style>